<template>
  <div class="bank-account-container">
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
    ></admin-filter>

    <order-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1100"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">
      <td slot="bkcode" slot-scope="props">{{ props.item.bkcode }}</td>
      <td slot="actnumber" slot-scope="props">{{ props.item.actnumber }}</td>
      <td slot="bkname" slot-scope="props">{{ props.item.bkname }}</td>
      <td slot="account_time" slot-scope="props">{{ props.item.account_time }}</td>
      <td slot="name" slot-scope="props">{{ props.item.name }}</td>
      <td slot="price" slot-scope="props">{{ props.item.price|currencyNum }}</td>
      <td slot="bank" slot-scope="props">{{ props.item.bank }}</td>
      <td slot="content" slot-scope="props">{{ props.item.content }}</td>
      <td slot="invoice_number" slot-scope="props">
        <div class="flex-center" style="gap:8px" v-if="props.item.invoice">
          <router-link :to="`/office/admin/ship_agency/order_detail?id=${props.item.invoice.order}`">
            {{ props.item.invoice.invoice_number}}
          </router-link>
          <i class="material-icons btn-cancel" @click="clickCancel(props.item)">close</i>
        </div>
        <button v-else class="button btn-match is-primary" @click="clickMatch(props.item)">신청서 매칭</button>
      </td>
    </order-table>
    <invoice-modal v-if="vModal" :item="selectedItem" @close="onCloseModal"
                      @select="onSelect"></invoice-modal>
  </div>
</template>

<script>
  import ShipAgencyMixin from "../../../mixins/ShipAgencyMixin";
  import { SweetModal } from "sweet-modal-vue";
  import InvoiceModal from "./InvoiceModal";

  export default {
    name: "BankAccount",
    components: {InvoiceModal},
    commponents: {
      SweetModal
    },
    mixins: [
      ShipAgencyMixin
    ],
    created() {
      this.init();
    },
    data() {
      return {
        selectedItem: undefined,
        vModal: false
      }
    },
    methods: {
      init() {
        this.initializing('bank_account','shipagency/bank_account')
      },
      getDataFromServer() {
        this.getData();
      },
      onCloseModal() {
        setTimeout(()=>{
          this.vModal = false;
        },500);
      },
      onSelect(item) {
        this.$axios.patch(`admin/shipagency/bank_account/${this.selectedItem.id}`, {invoice: item}).then(res => {
          if(res.status === 200) {
            this.selectedItem.invoice = res.data.invoice;
          }
        });
      },
      clickMatch(item) {
        this.selectedItem = item;
        this.vModal = true;
      },
      clickCancel(item) {
        if(confirm('매칭을 취소하겠습니까?')) {
          this.$axios.patch(`admin/shipagency/bank_account/${item.id}`, {cancel: true}).then(res => {
            if(res.status === 200) {
              item.invoice = undefined;
            }
          });
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .btn-cancel
    font-size 14px
    cursor pointer
    width 20px
    height 20px
    border 1px solid #ddd
    border-radius 100%
    display flex
    align-items center
    justify-content center
  .btn-cancel:hover
    background-color #a0a0a0
    color white

  .btn-match
    font-size 12px !important
    height 28px
    width fit-content
</style>
